import { t } from 'i18next'
import * as z from 'zod'

import { EmailChangeModalFormVO } from './type'

const EMAIL_MIN_LENGTH = 1
const EMAIL_MAX_LENGTH = 255

export const schema = z.object({
  newEmail: z
    .string()
    .min(EMAIL_MIN_LENGTH, t('auth.validation.requiredInput'))
    .max(
      EMAIL_MAX_LENGTH,
      t('auth.validation.maxLength', { length: EMAIL_MAX_LENGTH })
    )
    .email(t('auth.validation.invalidEmail')),
})

export const formLabels: Record<keyof EmailChangeModalFormVO, string> = {
  newEmail: t('auth.email.newEmail'),
}
